"use strict";

const { formSubmitEvents } = require("../helpers/gtmHelpers");
var scrollAnimate = require("./scrollAnimate");

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = "alert-success";
    } else {
        status = "alert-danger";
    }

    if ($(".email-signup-message").length === 0) {
        $("body").append(
            "<div class=\"email-signup-message\"></div>"
        );
    }
    $(".email-signup-message")
        .append("<div class=\"email-signup-alert text-center " + status + "\">" + data.msg + "</div>");

    setTimeout(function () {
        $(".email-signup-message").remove();
        button.removeAttr("disabled");
    }, 3000);
}

/**
 * Handles the newsletter subscription error
 * @param {Object} responseData - response data from the server
 * @returns {void}
 */
const handleNewsletterSubscriptionError = (responseData) => {
    const responseErrorMsgEl = document.querySelector(".newsletter-signup-wrapper .response-error-msg");

    if (!responseErrorMsgEl) return;

    if (!responseData || !responseData.error || !responseData.msg) {
        responseErrorMsgEl.classList.remove("d-none");
        return;
    }

    responseErrorMsgEl.innerHTML = responseData.msg;
    responseErrorMsgEl.classList.remove("d-none");
};

module.exports = function () {
    $(".back-to-top").click(function () {
        scrollAnimate();
    });

    $(".footer-newsletter-signup-form").on("submit", function (e) {
        e.preventDefault();

        const form = $(this);
        const submitButton = form.find("button[type=submit]");
        const sectionWrapper = $(".newsletter-signup-wrapper");
        const url = form.attr("action");
        const email = $("input[name=newsletterEmail]").val();
        const preference = $("input[name=preference]:checked").val();
        const token = $("input[name=csrf_token]").val();
        const responseErrorMsgEl = document.querySelector(".newsletter-signup-wrapper .response-error-msg");

        const newsLetterData = {
            email: email,
            preference: preference,
            csrf_token: token,
            source: "web_footer"
        };

        sectionWrapper.spinner().start();
        submitButton.attr("disabled", true);

        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: newsLetterData,
            success: function (data) {
                if (data.success) {
                    if (responseErrorMsgEl) {
                        responseErrorMsgEl.classList.add("d-none");
                    }

                    formSubmitEvents("Newsletter signup", email);
                    $(".newsletter-signup-wrapper").addClass("d-none");
                    $(".subscribed-wrapper").removeClass("d-none");
                    return;
                }

                handleNewsletterSubscriptionError(data);
            },
            error: function () {
                handleNewsletterSubscriptionError();
            }
        });

        submitButton.attr("disabled", false);
        sectionWrapper.spinner().stop();
    });

    $(".subscribe-email").on("click", function (e) {
        e.preventDefault();
        var url = $(this).data("href");
        var button = $(this);
        var emailId = $("input[name=hpEmailSignUp]").val();
        $.spinner().start();
        $(this).attr("disabled", true);
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: {
                emailId: emailId
            },
            success: function (data) {
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });
};
